var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff00f3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 5,
    x2: 24,
    y1: 16.717,
    y2: 16.717,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    },
    fill: "url(#b)",
    fillRule: "evenodd",
    d: "M15.48 4.434c-3.021 0-5.48 2.469-5.48 5.5 0 3.03 2.459 5.5 5.48 5.5 3.022 0 5.48-2.47 5.48-5.5.001-3.031-2.458-5.5-5.48-5.5zm0 1c2.48 0 4.481 2.007 4.48 4.5 0 2.492-2 4.5-4.48 4.5a4.483 4.483 0 0 1-4.48-4.5c0-2.493 2.001-4.5 4.48-4.5zm-2.98 11c-4.148 0-7.5 3.368-7.5 7.529v4.516a.5.5 0 0 0 .5.5h3.854a.5.5 0 0 0 .292 0h11.708a.5.5 0 0 0 .292 0H25.5a.5.5 0 0 0 .5-.5v-4.516c0-4.161-3.352-7.53-7.5-7.53h-6zm0 1h6c3.609 0 6.5 2.902 6.5 6.529v4.016h-3v-4.024a.5.5 0 0 0-.508-.506.5.5 0 0 0-.492.506v4.024H10v-4.024a.5.5 0 0 0-.508-.506.5.5 0 0 0-.492.506v4.024H6v-4.016c0-3.627 2.891-6.53 6.5-6.53z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.224917d795888cc7f8ca2627480d0c56.svg";
export { ForwardRef as ReactComponent };